import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import { useState } from 'react';
import LoadingButton from '@/components/Buttons/LoadingButton';
import { resendPostIntakeEmail } from '@/services/EmailService';
import { errorSnackbar, successSnackbar } from '@/utils/snackbar';

interface Props {
    prospectId: string;
    contactId: string;
    contactName: string;
    onClose(): void;
}

export default function ResendPostIntakeDialog({
    prospectId,
    contactId,
    contactName,
    onClose,
}: Props) {
    const [isSending, setIsSending] = useState(false);

    const handleSend = async () => {
        setIsSending(true);
        try {
            await resendPostIntakeEmail({
                prospectId,
                contactId,
            });
            successSnackbar('Post-intake email sent successfully');
            onClose();
        } catch (error: any) {
            errorSnackbar(error?.response?.data || 'Failed to send post-intake email');
        } finally {
            setIsSending(false);
        }
    };

    return (
        <Dialog open onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Send Post-Intake Email</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ paddingTop: '8px' }}>
                    <Typography variant="body2">
                        {`Would you like to send the post-intake email to ${contactName}?`}
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions sx={{ padding: '16px 24px' }}>
                <Button variant="outlined" onClick={onClose}>
                    Cancel
                </Button>
                <LoadingButton variant="contained" onClick={handleSend} loading={isSending}>
                    Send
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
